import React, {
  ReactNode,
  useContext,
  createContext,
  Dispatch,
  useReducer
} from 'react'
import {
  ActionType,
  initialState,
  jiraIntegrationReducer,
  JiraPageState
} from './state/jira-integration-page.state'

interface Context {
  state: JiraPageState
  dispatch: Dispatch<ActionType>
}

interface JiraIntegrationPageProviderProps {
  state: Partial<JiraPageState>
  children: ReactNode
}

export const JiraIntegrationPageContext = createContext<Context | null>(null)

export const JiraIntegrationPageProvider = (
  props: JiraIntegrationPageProviderProps
) => {
  const [state, dispatch] = useReducer(jiraIntegrationReducer, {
    ...initialState,
    ...props.state
  })
  return (
    <JiraIntegrationPageContext.Provider value={{ state, dispatch }}>
      {props.children}
    </JiraIntegrationPageContext.Provider>
  )
}

export const wronglyUsedContextErrorMessage =
  'useJiraIntegrationPage must be used within JiraIntegrationPageProvider'

export const useJiraIntegrationPage: () => Context = () => {
  const context = useContext(JiraIntegrationPageContext)
  if (!context) {
    throw new Error(wronglyUsedContextErrorMessage)
  }
  return context
}
